export default __webpack_public_path__ + "static/media/codecommit.d62a3b96.svg";